import React, { useState } from 'react';
import logo from '../assets/Logo_1.png';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { HashLink as ScrollLink } from 'react-router-hash-link';

const NavLinks = ({ showLinkslg, showLinkssm, slide, hideLinks }) => {
  return (
    <div
      className={`${showLinkslg} ${showLinkssm} ${
        slide ? '' : 'not__sliding'
      } `}
    >
      <div className="links-container">
        <Link to={'/'} className="link" onClick={hideLinks}>
          Why Fitness-Space
        </Link>
        <ScrollLink to={'#testimonial'} className="link" onClick={hideLinks}>
          Stories
        </ScrollLink>
        <Link to={'/'} className="link" onClick={hideLinks}>
          Learn
        </Link>
        <Link to={'/'} className="link" onClick={hideLinks}>
          Faqs
        </Link>
        <Link to={'/'} className="link get-started-link" onClick={hideLinks}>
          Get Started
        </Link>
      </div>
    </div>
  );
};

const Header = () => {
  const [slide, setSlide] = useState(false);
  const [toggleIcon, setToggleIcon] = useState(true);

  const showLinks = () => {
    setSlide(!slide);
    setToggleIcon(!toggleIcon);
  };
  const hideLinks = () => {
    setSlide(!slide);
    setToggleIcon(!toggleIcon);
  };

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  return (
    <div className="nav-bar">
      <div className="nav-bar-container">
        <div className="logo-container">
          <img src={logo} alt="fitness space logo" className="logo" />
        </div>
        {toggleIcon ? (
          <div className="links-bars" onClick={showLinks}>
            <FontAwesomeIcon icon={faBars} />
          </div>
        ) : (
          <div
            className="links-times"
            style={toggleIcon ? '' : { display: 'block' }}
            onClick={hideLinks}
          >
            <FontAwesomeIcon icon={faTimes} />
          </div>
        )}
        <NavLinks showLinkslg={'show-links-lg'} />
      </div>
      <NavLinks
        showLinkssm={'show-links-sm'}
        slide={slide}
        hideLinks={hideLinks}
      />
      {slide ? <div className={'overlay'} onTouchStart={hideLinks}></div> : ''}
    </div>
  );
};

export default Header;
